<ng-container *ngIf="isExternalBootstrapRoute; else standardApp">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #standardApp>
  <abp-loader-bar></abp-loader-bar>
  <abp-dynamic-layout [defaultLayout]="defaultLayout"></abp-dynamic-layout>

  <ca-idle-timeout-modal></ca-idle-timeout-modal>
  <ca-video-player> </ca-video-player>
  <ca-column-configurator></ca-column-configurator>
</ng-template>
